import { render } from "./SliderInput.vue?vue&type=template&id=1997ead5&scoped=true"
import script from "./SliderInput.vue?vue&type=script&lang=js"
export * from "./SliderInput.vue?vue&type=script&lang=js"

import "./SliderInput.vue?vue&type=style&index=0&id=1997ead5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1997ead5"]])

export default __exports__